cardSettingModule = angular.module('card.setting', [])

cardSettingModule.directive "cardSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "$rootScope", ($window, $timeout, $compile, $templateCache, ns, $rootScope) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->

    widgetEl = angular.element("[data-block-id='#{attrs.widgetId}']")
    widgetEl.find("a").attr "href", "#"
    wrapper = widgetEl.find ".strwcrd"
    imageSizeWrapper = widgetEl.find ".strwcrd__image-size"
    imageWrapper = widgetEl.find ".strwcrd__image-wrapper"
    imageDefaultCap = widgetEl.find ".default-cap"
    title = widgetEl.find ".strwcrd__title"
    price = widgetEl.find ".strwcrd__price"
    descWrapper = widgetEl.find ".strwcrd__desc-wrapper"
    desc = widgetEl.find ".strwcrd__desc"
    button = widgetEl.find ".strwcrd__button"


    widgetEl.find(".strwcrd-link__nodecoration").attr "href", "javascript: void(0)"
    widgetEl.find(".strwcrd-link__nodecoration").removeAttr "target"



    setSiterWidget = (newval) ->
      wrapper.css newval.wrapper_style

    setImage = (newval) ->
      if !newval.show_image
        imageSizeWrapper.css 'display', 'none'
      else
        imageSizeWrapper.css 'display', 'block'

      if newval.image_attributes.source_url
        if imageDefaultCap.length
          imageDefaultCap.remove()
          if newval.image_attributes.stretch
            imageTag = "<div class='strwcrd__image strwcrd__image_cover' style='background-image: url(#{newval.image_attributes.source_url})'></div>"
          else
            imageTag = "<img class='strwcrd__image' src='#{newval.image_attributes.source_url}' alt='#{newval.title}'>"
          imageWrapper.prepend "#{imageTag}"
          image = imageSizeWrapper.find ".strwcrd__image"
        else
          image = imageSizeWrapper.find ".strwcrd__image"
          if newval.image_attributes.stretch
            image.attr 'style', "background-image: url(#{newval.image_attributes.source_url})"
          else
            image.attr 'src', newval.image_attributes.source_url
        if newval.image_attributes.stretch
          image = widgetEl.find ".strwcrd__image"
          image.remove()
          imageWrapper.prepend "<div class='strwcrd__image strwcrd__image_cover' style='background-image: url(#{newval.image_attributes.source_url})'></div>"
        else
          image = widgetEl.find ".strwcrd__image"
          image.remove()
          imageWrapper.prepend "<img class='strwcrd__image' src='#{newval.image_attributes.source_url}' alt='#{newval.title}'>"
      else
        if newval.image_attributes.stretch
          imageDefaultCap.css 'width': '100%'
        else
          imageDefaultCap.css 'width': ''

      imageSizeWrapper.css
        'height': newval.image_wrapper_height

      scope.data.image_style.backgroundPosition = "center"

      scope.data.image_style.height = newval.image_wrapper_height
      imageWrapper.css newval.image_style


    setTitle = (newval) ->
      if !newval.show_title
        title.css 'display', 'none'
      else
        if title
          title.css 'display', 'block'
        else
          templateTitle = "<span class='strwcrd__title' style='font-size: #{newval.title_style.fontSize}; color: #{newval.title_style.color}; margin: #{newval.title_style.margin}'>#{newval.title}</span>"
          if imageSizeWrapper
            imageSizeWrapper.after templateTitle
          else
            wrapper.prepend templateTitle
          title = widgetEl.find ".strwcrd__title"
      title
        .css newval.title_style


    setPrice = (newval) ->
      if !newval.show_price
        price.css 'display', 'none'
      else
        if price
          price.css 'display', 'block'
        else
          templatePrice = "<span class='strwcrd__price' style='font-size: #{newval.price_style.fontSize}; color: #{newval.price_style.color}; margin: #{newval.price_margin}'>#{newval.price}</span>"
          if title
            title.after templatePrice
          else if imageSizeWrapper
            imageSizeWrapper.after templatePrice
          else
            wrapper.prepend templatePrice
          price = widgetEl.find ".strwcrd__price"
      price
        .css newval.price_style

    setDesc = (newval) ->
      if !newval.show_description
        desc.css 'display', 'none'
      else
        if desc
          desc.css 'display', 'block'
        else
          templateDesc = "<div class='strwcrd__desc-wrapper' style='height: #{newval.description_wrapper_height};'><span class='strwcrd__desc' style='font-size: #{newval.description_style.fontSize}; color: #{newval.description_style.color}; margin: #{newval.description_style.margin}'>#{newval.description}</span></div>"
          if title
            title.after templateDesc
          else if imageSizeWrapper
            imageSizeWrapper.after templateDesc
          else if price
            price.after templateDesc
          else
            wrapper.prepend templateDesc
          descWrapper = widgetEl.find ".strwcrd__desc-wrapper"
          desc = widgetEl.find ".strwcrd__desc"
      descWrapper.css
        'height': newval.description_wrapper_height
      desc
        .css newval.description_style

    setButton = (newval) ->
      if !newval.show_button
        button.css 'display', 'none'
      else
        if button
          button.css 'display', 'inline-block'
        else
          templateButton = "<a class='strwcrd__button' href='#{newval.button_attributes.link_href}' style='background-color: #{newval.button_attributes.style_attributes.backgroundColor}; border: #{newval.button_attributes.style_attributes.border}; border-radius: #{newval.button_attributes.style_attributes.borderRadius}; padding: #{newval.button_attributes.style_attributes.padding}; font-size: #{newval.button_attributes.style_attributes.fontSize}; color: #{newval.button_attributes.style_attributes.color}; margin: #{newval.button_attributes.margin}'>#{newval.button_attributes.value}</a>"
          if title
            title.after templateButton
          else if imageSizeWrapper
            imageSizeWrapper.after templateButton
          else if price
            price.after templateButton
          else if desc
            desc.after templateButton
          else
            wrapper.prepend templateButton
          button = widgetEl.find ".strwcrd__button"
      button
        .css newval.button_attributes.style_attributes
      if newval.button_attributes.target_blank
        button.attr "target", "_blank"
      if newval.button_attributes.click_action == 'open_link'
        button.attr 'href', newval.button_attributes.link_href
      else
        button
          .addClass 'link-anchor'
          .attr 'href', "##{newval.button_attributes.scroll_section_id}"

    listener = scope.$watch "data", (newval, oldval) ->
      return false if newval is oldval
      setSiterWidget newval
      setTitle newval
      setImage newval
      setPrice newval
      setDesc newval
      setButton newval
      return
    , true

    scope.$on "$destroy", ->
      listener()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/card/card.directive.coffee